import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const StorySection = () => {
  return (
    <section id="story" className="story-section">
      <div className="container">
        <div className="story-content">
          <img src={IMAGE_PATHS.magrisim} alt="Transformação antes e depois" className="story-img" />
          <div className="story-text">
            <h2>
              MagriSim <span className="story-highlight">não é remédio</span>, é o
              resultado de anos de pesquisa
            </h2>
            <p>
              Desenvolvido com base em uma fórmula americana testada, validada e
              eleita por especialistas, o Magrisim é <strong>100% natural</strong> e
              reúne os ativos mais eficazes do mundo para auxiliar no emagrecimento
              saudável. Sem químicos, sem fórmulas sintéticas e sem efeitos colaterais.{' '}
              <strong>Não é um remédio, é um suplemento em gotas.</strong>
            </p>
            <div className="anvisa-seal">
              <img src={IMAGE_PATHS.anvisa} alt="Selo de aprovação ANVISA" />
            </div>
            <div className="beneficios-seal mobile-only">
              <img src={IMAGE_PATHS.beneficios} alt="Benefícios do Magrisim" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
